
export const FASHION_BRANDS: string[] = [
    'Mavi', 'LC Waikiki', 'Koton', 'DeFacto', 'Colin\'s', 'Network', 'Beymen',
    'Vakko', 'İpekyol', 'Damat', 'Tween', 'Zara', 'H&M', 'Pull & Bear',
    'Stradivarius', 'Bershka', 'Trendyol', 'Hepsiburada', 'Modanisa', 'Lotto',
    'Hummel', 'Penti', 'US Polo Assn.', 'Tommy Hilfiger', 'Calvin Klein', 'Diesel',
    'Puma', 'New Balance', 'Skechers', 'Columbia', 'The North Face',
    'Mango', 'Massimo Dutti', 'COS', 'Arket', '& Other Stories',
    'Uniqlo', 'Muji', 'Desigual', 'Superdry', 'Jack & Jones'
];

export const CLOTHING_SIZES_INT = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];
export const CLOTHING_SIZES_NUM = ['32', '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54', '56'];
export const SHOE_SIZES_EUR = ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48'];

export const FASHION_MATERIALS = [
    'Pamuk (Cotton)', 'Yün (Wool)', 'İpek (Silk)', 'Keten (Linen)', 'Kaşmir',
    'Polyester', 'Naylon', 'Akrilik', 'Viskon', 'Likra (Elastan)',
    'Deri', 'Süet', 'Suni Deri', 'Vegan Deri', 'Kot (Denim)', 'Kadife'
];

export const FASHION_PATTERNS = [
    'Düz (Sade)', 'Çizgili', 'Kareli', 'Ekose', 'Puantiyeli',
    'Çiçekli', 'Hayvan Desenli', 'Geometrik', 'Baskılı', 'Logolu'
];

export const FASHION_STYLES = [
    'Klasik', 'Casual (Günlük)', 'Sportif', 'Bohem', 'Retro/Vintage',
    'Modern', 'Minimalist', 'Glamour', 'Sokak Stili (Streetwear)'
];

export const WATCH_BRANDS: string[] = [
    'Rolex', 'Omega', 'Tag Heuer', 'Longines', 'Tissot', 'Seiko', 'Casio', 'Citizen', 'Fossil', 'Swatch', 'Daniel Wellington', 'MVMT',
    'Breitling', 'IWC', 'Panerai', 'Audemars Piguet', 'Patek Philippe', 'Vacheron Constantin', 'Jaeger-LeCoultre', 'Hublot', 'Richard Mille',
    'Frederique Constant', 'Rado', 'Baume & Mercier', 'Bell & Ross', 'Oris', 'Nomos', 'Junghans', 'Mido', 'Raymond Weil', 'Victorinox', 'Hamilton',
    'Apple Watch', 'Samsung Galaxy Watch', 'Garmin', 'Fitbit', 'Huawei Watch', 'Xiaomi Mi Band', 'Amazfit', 'Withings'
];

export const HOME_APPLIANCE_BRANDS: string[] = [
    'Arçelik', 'Beko', 'Bosch', 'Siemens', 'Samsung', 'LG', 'Vestel', 'Regal', 'Altus', 'Profilo', 'Hotpoint', 'Ariston', 'Indesit',
    'Whirlpool', 'Electrolux', 'Grundig', 'Candy', 'Hoover', 'Smeg'
];

export const SPORTS_BRANDS: string[] = [
    'Nike', 'Adidas', 'Puma', 'Under Armour', 'Reebok', 'Converse', 'New Balance', 'Asics', 'Mizuno', 'Salomon', 'Decathlon',
    'Wilson', 'Spalding', 'Bauer', 'Ccm', 'Franklin', 'Rawlings', 'Trek', 'Specialized', 'Giant', 'Cannondale', 'Scott', 'Merida', 'Bianchi', 'Cube', 'BMC'
];
